import React from 'react'

type SubmitProps = {
  wrapperStyle?: string
  children: string
}

const Submit: React.FC<SubmitProps> = ({
  wrapperStyle = '',
  children,
}) => {
  return (
    <div className={`submit-cta ${wrapperStyle}`}>
      <button type="submit" className="submit-cta__submit">
        {children}
      </button>
    </div>
  )
}

export default Submit
